module.exports = __webpack_public_path__ + "static/media/arrow-back.ba910f52.png";